import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { RequisitionsApi } from '../../../../api/Corporates/Requisitions'
import { DeliveryOrderApi } from '../../../../api/Purchase/DeliveryOrder'
import { OrdersApi } from '../../../../api/Purchase/Orders'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import RequisitionsForm from '../../../../components/Corporate/Requisitions/AddRequisitions/RequisitionsForm'
import RequisitionsLinesCont from '../../../../components/Corporate/Requisitions/Lines/RequisitionsLinesCont'
import DeliveryOrderList from '../../../../components/Purchasing/DeliveryOrder/DeliveryOrderList'
import OrderList from '../../../../components/Purchasing/Order/OrderList'
import ReadyToOrderCont from '../../../../components/Purchasing/Order/ReadyToOrderCont'
import VouchersList from '../../../../components/Purchasing/Voucher/VouchersList'
import style from '../../../../components/Sales/style.css'
import AmountDetails from '../../../../elements/AmountDetails'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import _, { isEmpty } from 'lodash'
import { strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'

const { TabPane } = Tabs

function AddRequisitions(props) {
  const {
    submitting,
    update,
    formRef,
    requisition,
    fetching,
    actions,
    handleActions,
    fetchingActions,
    fetch,
    isNew,
    remove,
    removing,
    isUpdatable,
    isRemovable,
    submit,
  } = props

  const Operations = ({ requisition, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a data-testid={a.value}>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const { data: vouchers, fetching: fetchingVouchers, fetch: fetchVouchers } = useFetch({
    url: `requisitions/${requisition._key}/vouchers?select=*`,
    dependencyArray: [requisition._key],
    dontFetch: _.isEmpty(requisition, '_key'),
  })

  const { data: listDelivery, fetching: fetchingDelivery, fetch: fetchDelivery } = useFetch({
    url: `delivery/?select=*&reqs=${requisition._key}`,
    dependencyArray: [requisition._key],
    dontFetch: isEmpty(requisition._key),
  })

  const { data: cachedListOrders, fetching: fetchingOrders, fetch: fetchOrders } = useFetch({
    url: `orders/reqs/${requisition._key}`,
    dependencyArray: [requisition._key],
    dontFetch: isEmpty(requisition._key)
  })

  const { list: listOrders, company: companyOrder, onChangeCompany: onChangeCompanyOrder } = useListCompanyFilter(
    cachedListOrders,
    fetchingOrders
  )

  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <LinkHeader
        title={'Requisition'}
        link={{
          pathname: `/clients/enquiries/${_.get(requisition, 'enquiry._id', '').replace('activities/', '')}/update`,
        }}
        code={_.get(requisition, 'enquiry.code')}
        name={_.get(requisition, 'enquiry.title')}
        visible={!_.isEmpty(_.get(requisition, 'enquiry'))}
      />
      <LinkHeader
        title={'Requisition'}
        link={{
          pathname: `/clients/orders/${_.get(requisition, 'sales._id', '').replace('sales/', '')}/update`,
        }}
        code={_.get(requisition, 'sales.code')}
        name={_.get(requisition, 'sales.title')}
        visible={!_.isEmpty(_.get(requisition, 'sales'))}
        type={'Sales Order'}
      />

      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/requisitions`}>Requisitions</Breadcrumb.Item>
            <Breadcrumb.Item>{strVal(requisition, 'code')}</Breadcrumb.Item>
          </Breadcrumb>

          <Fragment>
            <Col span={17}>
              <h3 className={style.title}>
                {!isNew && (
                  <Fragment>
                    <h2 className={'icon-text-header'}>
                      <Icon
                        type="barcode"
                        style={{
                          marginRight: '5px',
                          color: '#08c',
                        }}
                      />
                      <Tooltip title="Order Code">{strVal(requisition, 'code')}</Tooltip>
                    </h2>
                    <Status value={_.capitalize(strVal(requisition, 'status'))} />
                    <Operations
                      style={{ marginTop: '10px' }}
                      requisition={requisition}
                      status={strVal(requisition, 'status')}
                    />
                    <br />

                    <Tooltip title="Order Type">{strVal(requisition, 'type')}</Tooltip>
                  </Fragment>
                )}
              </h3>
            </Col>
            <Col span={5}>
              <AmountDetails doc={requisition} />
            </Col>
            <RefreshButton onClick={fetch} />
          </Fragment>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="details">
          <TabPane tab="Details" key="details">
            <Row>
              <FooterButtons
                remove={remove}
                removing={removing}
                submit={submit}
                update={isUpdatable && update}
                submitting={submitting}
                title={'Requisitions'}
                isNew={isNew}
                isEdit={isUpdatable}
              />
              <RequisitionsForm ref={formRef} {...props} />
              <FooterButtons
                remove={remove}
                removing={removing}
                submit={submit}
                update={isUpdatable && update}
                submitting={submitting}
                title={'Requisitions'}
                isNew={isNew}
                isEdit={isUpdatable}
              />
            </Row>
          </TabPane>
          <TabPane disabled={isNew} tab={'Requisition Lines'} key="#lines">
            <RequisitionsLinesCont fetchRequisition={fetch} isUpdatable={isUpdatable} requisition={requisition} />
          </TabPane>

          <TabPane
            disabled={isNew}
            tab={
              <span>
                <Icon type="file-text" />
                Ready To Order
              </span>
            }
            key="#readyToOrder">
            <ReadyToOrderCont requisitionID={requisition._key} />
          </TabPane>

          <TabPane
            disabled={isNew}
            tab={
              <span>
                <Icon type="file-text" />
                Vendor Order
              </span>
            }
            key="#vendor">
            <OrderList
              {...{
                listOrders,
                fetchingOrders,
                fetchOrders,
                companyOrder,
                onChangeCompanyOrder,
                hideCompany: true,
              }}
            />
          </TabPane>

          <TabPane disabled={isNew} tab={'Delivery Order'} key="#delivery">
            <DeliveryOrderList
              {...{
                list: listDelivery,
                fetching: fetchingDelivery,
                fetch: fetchDelivery,
                hideCompany: true,
                hideCreate: true,
              }}
            />
          </TabPane>
          <TabPane disabled={isNew} tab={'Vendor Claims'} key="#vouchers">
            <VouchersList
              requisitionID={requisition._key}
              list={vouchers}
              fetching={fetchingVouchers}
              fetch={fetchVouchers}
            />
          </TabPane>
          <TabPane disabled={isNew} tab="Documents" key="files">
            <Documents editable={true} footer={false} category={false} owner={requisition} />
          </TabPane>
          <TabPane disabled={isNew} tab={'History'} key="#history">
            <History loading={fetching} owner={requisition} />
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddRequisitions
